import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUploadOvertimeSalaryMutation } from "../../features/payrollSetting/payrollSettingApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";
import SuccessModal from "../Report/SuccessModal";

export default function OvertimeSalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const navigate = useNavigate();
  const [uploadOvertimeSalary, { isLoading, isError, error, isSuccess }] =
    useUploadOvertimeSalaryMutation();
  useError(isError, error, "Upload overtime salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Overtime salary updated successfully");
      handleOpen({ type: "SUCCESS" });
      // if (data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, navigate]);

  return (
    <>
      <UploadExcelModal
        open={open}
        handleClose={handleClose}
        isLoading={false}
        handler={setFormData}
        title="Update Overtime Salary Data in Bulk"
        warningText="Please enter the year as a four-digit number (e.g., 2025, 2024) and the month as a number (e.g., 1 for January, 12 for December)."
        downloadLink={"/sample-overtime-salary.xlsx"}
        footer={
          <Space size={12}>
            {childOpen?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={childOpen?.open}
                handleClose={childClose}
              />
            )}
            <Button
              className="modal-button"
              type="primary"
              loading={isLoading}
              onClick={() => uploadOvertimeSalary(formData)}
            >
              Upload
            </Button>
          </Space>
        }
      />
    </>
  );
}
